<template>
    <MainLayout>
        <div class="pagetitle">
            <h1>Editar rol</h1>
            <nav>
                <ol class="breadcrumb">
                    <li class="breadcrumb-item">
                        <router-link to="/">
                            <span>Dashboard</span>
                        </router-link>
                    </li>

                    <li class="breadcrumb-item active">
                        <router-link to="/Roles">
                            <span>Roles</span>
                        </router-link>
                    </li>

                    <li class="breadcrumb-item active">Editar Rol</li>
                </ol>
            </nav>
        </div>

        <section class="section dashboard">
            <RoleManagerComponent type="E" :roleId="roleId" />
        </section>
    </MainLayout>
</template>

<script>
import MainLayout from '../../../layouts/MainLayout';
import RoleManagerComponent from '@/components/Admin/Roles/RoleManagerComponent.vue';

export default {


    name: 'EditRole',

    components: {
        MainLayout,
        RoleManagerComponent,
    },

    computed: {

        roleId() {

            return Number(this.$route.params.id); // Obtener el ID de la URL
        }
    },
};
</script>